exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".document-link__documentLink___1AQCa{background:none;border:none;color:#00aeef;font-weight:700}.document-link__documentLink___1AQCa img{width:30px;margin-top:-3px;opacity:.5}.document-link__documentLink___1AQCa:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"documentLink": "document-link__documentLink___1AQCa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/document-link.scss
// module id = 1064
// module chunks = 0